import { Formik } from 'formik';
import React from 'react';
import { Redirect } from 'react-router';
import { useODEntityContext } from '..';
import { BlockingLoadBox } from '../../misc';
import { convertODValidatorToFormikValidator } from '../../validator/convertODValidatorToFormikValidator';
import { ODEntityState } from '../context/reducer';
import { ODEntityEditorReactstrap } from './reactstrap/ODEntityEditorReactstrap';
export function ODEntityEditorFormikWrapper(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var validator = props.validator, titleCreation = props.titleCreation, titleUpdate = props.titleUpdate, children = props.children, saveButtonName = props.saveButtonName, deleteButtonName = props.deleteButtonName, deleteConfirmOptions = props.deleteConfirmOptions, noCardWrap = props.noCardWrap, footerProps = props.footerProps, disableSubmit = props.disableSubmit, renderLoading = props.renderLoading, renderError = props.renderError;
    var _j = useODEntityContext(), state = _j.state, onSubmit = _j.onSubmit, isCreating = _j.isCreating;
    var formikValidator = React.useState(function () {
        return convertODValidatorToFormikValidator(validator);
    })[0];
    switch (state.state) {
        case ODEntityState.LoadingInitial:
            return React.createElement("div", null, (_b = (_a = renderLoading) === null || _a === void 0 ? void 0 : _a(), (_b !== null && _b !== void 0 ? _b : React.createElement("span", null))));
        case ODEntityState.LoadingInitialError:
            return React.createElement("div", null, (_h = (_f = (_c = renderError) === null || _c === void 0 ? void 0 : _c((_e = (_d = state.stateError) === null || _d === void 0 ? void 0 : _d.message, (_e !== null && _e !== void 0 ? _e : ''))), (_f !== null && _f !== void 0 ? _f : (_g = state.stateError) === null || _g === void 0 ? void 0 : _g.message)), (_h !== null && _h !== void 0 ? _h : '')));
        case ODEntityState.LoadingInitialSuccess:
            break;
    }
    var isLoading = state.loading, urlToRedirect = state.urlToRedirect;
    if (urlToRedirect) {
        return React.createElement(Redirect, { to: urlToRedirect });
    }
    return (React.createElement(Formik, { validate: formikValidator, initialValues: state.initialValue, onSubmit: function (v) {
            if (!disableSubmit) {
                return onSubmit(v);
            }
        }, enableReinitialize: true },
        React.createElement(React.Fragment, null,
            React.createElement(BlockingLoadBox, { show: isLoading }),
            React.createElement(ODEntityEditorReactstrap, { title: isCreating ? titleCreation : titleUpdate, saveButtonName: saveButtonName, deleteButtonName: !isCreating ? deleteButtonName : undefined, deleteConfirmOptions: deleteConfirmOptions, noCardWrap: noCardWrap, footerProps: footerProps }, children))));
}
//# sourceMappingURL=ODEntityEditorFormikWrapper.js.map